import { useEffect, useState } from 'react';

export default function ThankYouMiraPage() {
  const [copied, setCopied] = useState(false);

  const zoomInfo = `Zoomリンク:
https://zoom.us/j/94011540658?pwd=nlGNbBsiC2WW024YKMa0TtCOHtOZdQ.1

ミーティングID:
940 1154 0658

パスコード:
2026111`;

  const handleCopyAll = () => {
    navigator.clipboard.writeText(zoomInfo);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-50 via-rose-50 to-orange-50 text-gray-800 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-orange-200/20 rounded-full blur-3xl"></div>
      <div className="absolute top-40 right-20 w-40 h-40 bg-pink-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-40 left-1/4 w-48 h-48 bg-amber-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-1/3 w-36 h-36 bg-rose-200/20 rounded-full blur-3xl"></div>

      {/* Confetti Animation */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-fall"
            style={{
              left: `${Math.random() * 100}%`,
              top: `-${Math.random() * 20}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            <div 
              className="w-3 h-3 rounded-full"
              style={{
                backgroundColor: ['#FFA07A', '#FFB6A3', '#FFC8B4', '#FF6B9D', '#C084FC'][Math.floor(Math.random() * 5)]
              }}
            ></div>
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-6 py-20">
        {/* Success Icon */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full mb-6 shadow-2xl animate-bounce">
            <i className="ri-check-line text-white text-5xl"></i>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-amber-600 via-orange-600 to-rose-600 bg-clip-text text-transparent">
            お申し込み完了！
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 font-medium">
            ご登録ありがとうございます
          </p>
        </div>

        {/* Email Notice */}
        <section className="mb-12">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-orange-200">
            <div className="flex items-start gap-4 mb-6">
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-gradient-to-br from-blue-400 to-blue-600 rounded-full">
                <i className="ri-mail-line text-white text-2xl"></i>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-gray-800 mb-2">
                  案内メールをお送りしています
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  セミナー当日に向けた詳細情報を記載したメールをお送りしております。<br />
                  メールが届かない場合に備えて、以下のZoom情報をメモしておいてください。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Seminar Info */}
        <section className="mb-12">
          <div className="bg-gradient-to-br from-orange-100 to-pink-100 border-2 border-orange-300 rounded-3xl p-8 shadow-xl">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">
              セミナー情報
            </h2>
            
            <div className="bg-white/80 rounded-2xl p-6 mb-6">
              <p className="text-lg font-bold text-gray-700 mb-2">開催日時</p>
              <p className="text-3xl md:text-4xl font-bold text-orange-700 text-center">1月24日（土）21:00〜</p>
            </div>

            <div className="bg-white/80 rounded-2xl p-6">
              <p className="text-xl font-bold text-gray-800 mb-2 text-center">
                「最初の10人」と出会う<br />
                『スピリチュアル起業』突破口
              </p>
            </div>
          </div>
        </section>

        {/* Zoom Info */}
        <section className="mb-12">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-orange-200">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-purple-500 to-pink-500 rounded-full">
                <i className="ri-vidicon-line text-white text-2xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
                Zoom参加情報
              </h2>
            </div>

            <div className="bg-gradient-to-br from-amber-50 to-rose-50 rounded-2xl p-6 mb-6">
              <p className="text-red-600 font-bold text-center mb-4 flex items-center justify-center gap-2">
                <i className="ri-alert-line text-xl"></i>
                メールが届かない場合に備えて、必ずメモしてください
              </p>
              
              <div className="space-y-4 mb-6">
                <div className="bg-white rounded-xl p-4">
                  <p className="text-sm font-semibold text-gray-600 mb-2">Zoomリンク</p>
                  <p className="text-blue-600 break-all font-mono text-sm">
                    https://zoom.us/j/94011540658?pwd=nlGNbBsiC2WW024YKMa0TtCOHtOZdQ.1
                  </p>
                </div>

                <div className="bg-white rounded-xl p-4">
                  <p className="text-sm font-semibold text-gray-600 mb-2">ミーティングID</p>
                  <p className="text-2xl font-bold text-gray-800">940 1154 0658</p>
                </div>

                <div className="bg-white rounded-xl p-4">
                  <p className="text-sm font-semibold text-gray-600 mb-2">パスコード</p>
                  <p className="text-2xl font-bold text-gray-800">2026111</p>
                </div>
              </div>

              {/* 一括コピーボタン */}
              <button
                onClick={handleCopyAll}
                className="w-full bg-gradient-to-r from-purple-600 via-pink-600 to-rose-600 text-white px-8 py-4 rounded-xl font-bold text-lg hover:shadow-2xl transform hover:scale-105 transition-all flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-copy-line text-2xl"></i>
                {copied ? '✓ コピーしました！' : 'Zoom情報を一括コピー'}
              </button>
            </div>
          </div>
        </section>

        {/* Final Message */}
        <section className="text-center">
          <div className="bg-gradient-to-br from-rose-100 to-orange-100 rounded-3xl p-8 shadow-xl border-2 border-rose-300">
            <p className="text-xl md:text-2xl font-bold text-gray-800 mb-4">
              当日お会いできることを<br />
              楽しみにしております
            </p>
            <p className="text-gray-700 leading-relaxed">
              セミナー開始の5分前には<br />
              Zoomにご参加いただけますようお願いいたします
            </p>
          </div>
        </section>
      </div>

      <style>{`
        @keyframes fall {
          to {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0;
          }
        }
        .animate-fall {
          animation: fall linear infinite;
        }
      `}</style>
    </div>
  );
}
